type PwaUpdater = () => Promise<void>

let pwaUpdater: PwaUpdater | null = null

export function setPwaUpdater(updater: PwaUpdater): void {
  pwaUpdater = updater
}

export async function requestPwaUpdate(): Promise<'current' | 'unavailable'> {
  if (!pwaUpdater) return 'unavailable'

  await pwaUpdater()
  return 'current'
}

